import { Injectable } from "@angular/core";
import { AppConfig } from "../../app/app.config";
import { Platform } from "ionic-angular";
import { UserProvider } from "../user/user";
import { Me } from "../../models/user";
import { DeviceProvider } from "../device/device";
import { Api } from "../api/api";
import {
  LocalstorageProvider,
  KEYS,
} from "../../providers/localstorage/localstorage";

declare let Adjust: any;
declare let AdjustEvent: any;
declare let AdjustConfig: any;
declare let window: any;
declare let gtag: any;
declare let ytag: any;
declare const fbq: any;
declare let fpcAction: any;

@Injectable()
export class Tracker {
  private adjustStatuslocalStorageKey: string = "pv-adjust-status";
  private webTokenLocalStorageKey: string = "pv-web-track";

  private adjustTokenData: {} = {
    // 登録
    onboarding: "vpwveh",
    good_from_user_page: "rqwa9o",
    test_web: "lmfwx3",
  };

  private profileData: {} = {
    status: {
      type: "string",
      adjustToken: undefined,
      initialValue: (me: Me) => {
        return this.profileData["status"].getter(me);
      },
      getter: (me: Me) => {
        return me.getStatus();
      },
    },
    gender: {
      type: "string",
      adjustToken: undefined,
      initialValue: (me: Me) => {
        return this.profileData["gender"].getter(me);
      },
      getter: (me: Me) => {
        if (me.isMale()) {
          return "男性";
        } else {
          return "女性";
        }
      },
    },
    business_type: {
      type: "string",
      adjustToken: undefined,
      initialValue: (me: Me) => {
        return this.profileData["business_type"].getter(me);
      },
      getter: (me: Me) => {
        return me.getProperty().business_type;
      },
    },
    income_type: {
      type: "string",
      adjustToken: undefined,
      initialValue: (me: Me) => {
        return this.profileData["income_type"].getter(me);
      },
      getter: (me: Me) => {
        return me.getProperty().income_type;
      },
    },
    age: {
      type: "string",
      adjustToken: undefined,
      initialValue: (me: Me) => {
        return this.profileData["age"].getter(me);
      },
      getter: (me: Me) => {
        const age: number = me.getAge();
        if (age < 20) return "~19";
        if (age < 25) return "20~24";
        if (age < 30) return "25~29";
        if (age < 35) return "30~34";
        if (age < 40) return "35~39";
        if (age < 45) return "40~44";
        if (age < 50) return "45~50";
        return "50~";
      },
    },
    residence_location: {
      type: "string",
      adjustToken: undefined,
      initialValue: "",
      getter: (me: Me) => {
        return me.getProperty().residence_location;
      },
    },
    drinking_type: {
      type: "string",
      adjustToken: undefined,
      initialValue: "",
      getter: (me: Me) => {
        return me.getProperty().drinking_type;
      },
    },
    cigarette_type: {
      type: "string",
      adjustToken: undefined,
      initialValue: "",
      getter: (me: Me) => {
        return me.getProperty().cigarette_type;
      },
    },
    input_rate: {
      type: "string",
      adjustToken: undefined,
      initialValue: "0",
      getter: (me: Me) => {
        const rate: number = me.propertyInputRate();
        if (rate < 10) return "~9";
        if (rate < 20) return "10~19";
        if (rate < 30) return "20~29";
        if (rate < 40) return "30~39";
        if (rate < 50) return "40~49";
        if (rate < 60) return "50~59";
        if (rate < 70) return "60~69";
        if (rate < 80) return "70~79";
        if (rate < 90) return "80~89";
        if (rate < 100) return "90~99";
        return "100";
      },
    },
    os: {
      type: "string",
      adjustToken: undefined,
      initialValue: (me: Me) => {
        return this.profileData["os"].getter();
      },
      getter: () => {
        if (this.platform.is("ios")) {
          return "iOS";
        } else if (this.platform.is("android")) {
          return "Android";
        }
      },
    },
  };

  constructor(
    private deviceProvider: DeviceProvider,
    private userProvider: UserProvider,
    private localStorageProvider: LocalstorageProvider,
    private platform: Platform,
    private api: Api
  ) {}

  init(): void {
    if (AppConfig.IS_BROWSER) {
      /*        Adjust.initSdk({
        appToken: AppConfig.ADJUST_APP_TOKEN,
        environment: AppConfig.ENV,
        logLevel: 'verbose'
      });  */
    }
  }

  // 循環参照になるため、Authをここで使えないので、meを引数として取得する
  update(me: Me): void {
    if (AppConfig.IS_BROWSER) {
      this.updateWebTrackToken();
      return;
    }
    this.setUserId(me);
    this.updateAdjustStatus();
    this.updateAdId();
  }

  track(name: string, properties?: {}): void {
    console.log("track:::::::: " + name);
    this.adjustTrack(name);
  }

  trackSearch(name: string, properties: {}): void {
    if (AppConfig.IS_BROWSER) return;
    this.adjustTrack(name);
  }

  trackViewContent(name: string, properties?: {}): void {
    if (AppConfig.IS_BROWSER) return;
    this.adjustTrack(name);
  }

  trackAddtoWishlist(name: string, properties?: {}): void {
    if (AppConfig.IS_BROWSER) return;
    this.adjustTrack(name);
  }

  trackPurchase(name: string, properties?: {}): void {
    if (AppConfig.IS_BROWSER) return;
    this.adjustTrack(name);
  }

  sendCVEvent(): void {
    this.sendGAEvent();
  }

  private sendGAEvent(): void {
    if (!this.useGA()) {
      return;
    }
    gtag("event", "conversion", {
      send_to: "AW-695412359/QKZ7CPLn87MBEIfNzMsC",
    });
  }

  sendYTAGEvent(ysaLabel: string, ydaLabel: string, value: number): void {
    if (!this.useYTAG()) {
      return;
    }
    ytag({
      type: "yss_conversion",
      config: {
        yahoo_conversion_id: "1001258044",
        yahoo_conversion_label: ysaLabel,
        yahoo_conversion_value: value.toString(),
      },
    });
    ytag({
      type: "yjad_conversion",
      config: {
        yahoo_ydn_conv_io: "4JbLBcB44yzV3-82vUTYJA..",
        yahoo_ydn_conv_label: ydaLabel,
        yahoo_ydn_conv_transaction_id: "",
        yahoo_ydn_conv_value: value.toString(),
      },
    });
  }

  sendZearEvent(): void {
    if (!this.useZear()) return;
    var uqid = "e925a889a31e2W2a";
    var gid = "215";
    var uid = "";
    var uid2 = "";
    var af = "";
    var pid = "";
    var amount = "";
    var a = document.createElement("script");
    a.src = "//ac.miraku.work/ac/action_js.php";
    a.id = "afadaction-" + Date.now();
    a.addEventListener("load", function() {
      new fpcAction(a.id).groupAction(gid, af, [uid, uid2], pid, amount, uqid);
    });
    document.head.appendChild(a);
  }

  private useGA(): boolean {
    return typeof gtag !== undefined;
  }

  private useYTAG(): boolean {
    return typeof ytag !== undefined;
  }

  private useZear(): boolean {
    return typeof fpcAction !== undefined;
  }

  trackEventForGA(eventName: string) {
    let datalayer: any = (window.dataLayer = window.dataLayer || []);
    datalayer.push({
      event: "appEvent",
      appEventCategory: eventName,
      appEventAction: "click",
      appEventLabel: "none",
    });
  }

  trackViewForGA(viewName: string, id: number) {
    let datalayer: any = (window.dataLayer = window.dataLayer || []);
    datalayer.push({
      event: "appScreenView",
      screenPath: viewName,
      screenName: viewName,
      uid: id.toString(),
    });
  }

  trackEventForGAWithParam(categoryName: string, uid: number) {
    let datalayer = (window.dataLayer = window.dataLayer || []);
    datalayer.push({
      event: "appEventWithParam",
      appEventCategory: categoryName,
      appEventAction: "click",
      appEventLabel: "none",
      cd1: uid,
    });
  }

  trackEventForFaceBookPixel(eventName: string) {
    fbq("trackCustom", eventName);
  }

  pushEventForFBViaGTM(eventName: string) {
    let datalayer = (window.dataLayer = window.dataLayer || []);
    datalayer.push({
      event: eventName,
    });
  }

  pushEventForPresco(meId: number, gender: number) {
    window.PrescoGroupAction(666, "", meId.toString(), gender.toString());
  }

  pushEventForAfb(meId: number, isMale: boolean) {
    const afbURL = "https://t.afi-b.com/commit/a10885C/";
    const afbParam: string = localStorage.getItem("afb");
    if (!afbParam) return;
    if (isMale) {
      this.api.get(afbURL + meId.toString() + "&mid=R880P&abm=" + afbParam);
      return;
    }
    this.api.get(afbURL + meId.toString() + "&abm=" + afbParam);
  }

  pushEventTj(): void {
    const transcationIDParam: string = this.localStorageProvider.getValue(
      KEYS.TransactionIDTj
    );
    if (!transcationIDParam) return;
    const tjURL = "http://tapjoy.go2cloud.org/SP2aX?transaction_id=";
    this.api.get(tjURL + transcationIDParam);
  }

  private setUserId(me: Me): void {
    if (AppConfig.IS_BROWSER) return;
    if (!this.isProduction()) return;
  }

  private updateWebTrackToken(): void {
    const webToken: string = localStorage.getItem(this.webTokenLocalStorageKey);
    if (webToken) {
      this.userProvider.updateWebTrackToken(webToken);
      localStorage.removeItem(this.webTokenLocalStorageKey);
    }
  }

  private updateAdjustStatus(): void {
    const adjustStatus: string = localStorage.getItem(
      this.adjustStatuslocalStorageKey
    );
    if (adjustStatus) {
      this.userProvider.updateAdjustStatus(adjustStatus);
      localStorage.removeItem(this.adjustStatuslocalStorageKey);
    }
  }

  private getAdjustToken(trackName: string): string {
    const adjustToken = this.adjustTokenData[trackName];
    return adjustToken ? adjustToken : undefined;
  }

  adjustTrackWithRevenue(
    trackName,
    price: number,
    transactionId: string
  ): void {
    if (AppConfig.IS_BROWSER) return;
    const token: string = this.getAdjustToken(trackName);
    if (!token) {
      console.warn("------ no token for adjust !! " + trackName + " ------");
      return;
    }
    if (typeof Adjust !== "undefined") {
      const adjustEvent = new AdjustEvent(token);
      adjustEvent.setRevenue(price, "JPY");
      adjustEvent.setTransactionId(transactionId);
      Adjust.trackEvent(adjustEvent);
    }
  }

  private adjustTrack(trackName): void {
    const token: string = this.getAdjustToken(trackName);
    if (!token) {
      console.warn("------ no token for adjust !! " + trackName + " ------");
      return;
    }
    if (typeof Adjust !== "undefined") {
      Adjust.trackEvent({ eventToken: token });
    }
  }

  private isProduction(): boolean {
    return AppConfig.ENV === "production";
  }

  private adjustAttributionCallback(attribution: any): void {
    if (!this.isProduction()) return;

    localStorage.setItem(
      this.adjustStatuslocalStorageKey,
      JSON.stringify(attribution)
    );
  }

  private updateAdId() {
    this.getAdvertisingId();
    this.getAdjustId();
  }

  private getAdvertisingId() {
    const successCallback = (id) => {
      this.deviceProvider.putAdvertisingId(id);
    };

    if (this.platform.is("ios")) {
      if (typeof Adjust !== "undefined") {
        Adjust.getIdfa(successCallback);
      }
    } else if (this.platform.is("android")) {
      if (typeof Adjust !== "undefined") {
        Adjust.getGoogleAdId(successCallback);
      }
    }
  }

  private getAdjustId() {
    if (typeof Adjust !== "undefined") {
      Adjust.getAdid((adid) => {
        this.deviceProvider.putAdjustId(adid);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/tracker/tracker.ts